<page-data-manager>
  <div class="row">
    <div class="ibox float-e-margins">
      <div class="ibox-content text-center p-md">
        <h2>Gerenciador de dados</h2>
        <p>Use o menu à esquerda para navegar nas seções disponíveis e gerenciar os dados da sua aplicação.</p>
      </div>
    </div>
  </div>
</page-data-manager>
